import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { ContentEditableStyleStates } from './types';

const styles = {
  root: ({ theme, props: { isDisabled } }) =>
    css({
      '& .content-editable--placeholder': {
        color: theme.colors.neutral.variant[40],

        ...(isDisabled && {
          color: theme.colors.neutral.variant[30],
        }),
      },
    }),
} satisfies Styles<ContentEditableStyleStates>;

export const useStyles = withStyles(styles);
